import { format, parse } from 'date-fns';

export const convertDate = (date: string | undefined): string => {
  if (!date) return '-';
  return format(new Date(date), 'yyyy-MM-dd, h:mm a');
};

export const formatInputDate = (date: Date): string => format(date, 'LL/dd/yyyy');

export const formatQueryDate = (date: Date): string => format(date, 'LL-dd-yyyy');

export const formatInputDateForBE = (date: Date): string => format(date, 'yyyy-LL-dd');

export const parseInputDate = (date: string): Date =>
  parse(date.replace(/[^\d]/g, ''), 'LLddyyyy', new Date());

export const formatDateRangeString = (start: Date, end: Date): string =>
  `${format(start, 'MMMM dd, yyyy')} - ${format(end, 'MMMM dd, yyyy')}`;

export const formatMonthAndYear = (month: number, year: number): string => {
  const date = new Date(year, month - 1);
  return format(date, 'LLLL, yyyy');
};
